export default {
  combine: {
    view_report: "@:ui.view Report",
    add_login: "@:ui.add Login",
    add_function: "@:ui.add Function",
    add_page: "@:ui.add Page",
    add_role: "@:ui.add Role",
    add_user: "@:ui.add User",
    edit_login: "@:ui.edit Login",
    edit_function: "@:ui.edit Function",
    edit_page: "@:ui.edit Page",
    edit_role: "@:ui.edit Role",
    edit_user: "@:ui.edit User",
    edit_password: "@:ui.edit @:ui.password",
    delete_login: "@:ui.delete Login",
    delete_function: "@:ui.delete Function",
    delete_page: "@:ui.delete Page",
    delete_role: "@:ui.delete Role",
    delete_user: "@:ui.delete User",
    assign_functions: "@:ui.assign Functions",
    assign_roles: "@:ui.assign Roles",
    confirm_password: "Confirm @:ui.password",
    change_password: "Change @:ui.password",
    old_password: "Old @:ui.password",
    new_password: "@:ui.new @:ui.password",
    account_status: "@:ui.account @:ui.status",
    account_settings: "@:ui.account @:ui.settings",
    layout_settings: "@:ui.layout @:ui.settings",
    confirm_security_code: "Confirm @:ui.security_code",
    first_time_login : "First Time Login",
    security_authentication: "Security Authentication",
    update_security: "Update Security",
    disable_security: "Disable Security",
    add_operator: "Add Operator",
    add_sub_account: "Add Sub Account",
    edit_operator: "Edit Operator",
    edit_member: "Edit Member",
    approve_ticket: "Approve Ticket",
    reject_ticket: "Reject Ticket",
    add_bank_account: "Add Bank Account",
    edit_bank_account: "Edit Bank Account",
    reset_threshold: "Reset Threshold",
    adjust_balance: "Adjust Balance",
    adjust_bank: "Adjust Bank",
    adjust_member: "Adjust Member",
    configure_bank_setting: "Configure Bank Setting",
    account_setup: "Account Setup",
    bank_transfer: "Bank Transfer",
    ticket_audit: "Ticket Audit",
    edit_bank_member: "Edit Bank Member",
    edit_ibank_account: "Edit iBank Account",
    edit_sub_account: "Edit Sub Account",
    view_member: "View Member",
    view_ticket: "View Ticket",
    edit_ticket: "Edit Ticket",
    view_bank_account: "View Bank Account",
    view_bank_member: "View Bank Member",
    view_ibank: "View iBank",
    edit_ibank: "Edit iBank",
    download_package: "Download Package",
    view_package: "View Package",
    edit_package: "Edit Package",
    view_vip: "View VIP",
    edit_vip: "Edit VIP",
    report: "Report",
    knock_off_promo: "Knock Off Promotion",
    add_member_promo: "Add Member Promotion",
    issue_bonus: "Issue Bonus",
    promo_package_download: "Promotion Package Download",
    edit_authority: "Edit Authority",
    reset_password: "Reset Password",
    update_password: "Update Password",
    member_summary: "Member Summary",
    reset_password: "Reset Password",
    issue_livestream_bonus: "Issue Livestream Bonus",
    member_reward: "Member Reward",
    reply_review: "Reply Review",
    edit_affiliate: "Edit Affiliate",
    edit_bank_affiliate: "Edit Bank Affiliate",
    raise_withdraw_ticket: "Raise Withdraw Ticket",
    qr_code: "QR Code",
  },
  authority: {
    account: "Account",
    ticket: "Ticket",
    bank: "Bank",
    promotion: "Promotion",
    vip: "VIP",
    vopr: "View Operator",
    eopr: "Edit Operator",
    vmb: "View Member",
    vtix: "View Ticket",
    etix: "Edit Ticket",
    vbkacc: "View Bank Account",
    ebkacc: "Edit Bank Account",
    vbkmb: "View Bank Member",
    ebkmb: "Edit Bank Member",
    vibk: "View iBank",
    eibk: "Edit iBank",
    dlpck: "Download Package",
    vpck: "View Package",
    epck: "Edit Package",
    vvip: "View VIP",
    evip: "Edit VIP",
    log: "Log",
    rpt: "Report"
  },
  short: {
    provider_status: "P.Status",
    own_status: "O.Status",
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bonus Amt",
    target_amount: "Trgt Amt",
    accumulate_win: "Acc Win",
    accumulate_turnover: "Acc TO",
    accumulate_amount: "Acc Amt",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_amount_threshold: "INC AMT TH",
    accumulate_incoming_amount: "ACCUM INC AMT",
    incoming_frequency_threshold: "INC AMT FRQ",
    accumulate_incoming_frequency: "ACCUM INC FRQ",
    outgoing_amount_threshold: "OG AMT TH",
    accumulate_outgoing_amount: "ACCUM OG AMT",
    outgoing_frequency_threshold: "OG AMT FRQ",
    accumulate_outgoing_frequency: "ACCUM OG FRQ",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",

  },
  ok: "OK",
  cancel: "Cancel",
  apply: "Apply",
  login: "Login",
  logout: "Logout",
  home: "Home",
  away: "Away",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  assign: "Assign",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  load: "Load",
  account: "Account",
  settings: "Settings",
  on: "ON",
  off: "OFF",
  new: "New",
  clear: "Clear",
  system: "System",
  functions: "Function | Functions",
  pages: "Page | Pages",
  roles: "Role | Roles",
  users: "User | Users",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  disabled: "Disabled",
  blocked: "Blocked",
  suspended: "Suspended",
  page_size: "Page Size",
  no_data: "No Data Available",
  status: "Status",
  login_attempt: "Login Attempt",
  user_roles: "Roles",
  layout: "Layout",
  mustang: "Operator Back Office",
  fullname: "Full Name",
  view: "View",
  moreinfo: "More Info",
  result: "Result",
  success: "Success",
  version: "Version",
  ipaddress: "IP Address",
  close: "Close",
  back: "Back",
  show: "Show",
  list: "List",
  login_id: "Login ID",
  login_name: "Login Name",
  filter: "Filter",
  ascending: "Ascending",
  descending: "Descending",
  logs: "Log | Logs",
  action_log: "Action Log",
  date_time: "DateTime",
  status_desc: "Status Desc",
  ip_address: "Ip Address",
  domain_name: "Domain Name",
  browser_agent: "Browser Agent",
  action_by: "Action By",
  target_id: "Target ID",
  target_action: "Target Action",
  details: "Details",
  key: "Key | Keys",
  value: "Value | Values",
  sort: "Sort",
  next: "Next",
  from: "From",
  to: "To",
  type: "Type",
  criteria: "Criteria",
  search_input: "Search Input",
  log: "Log",
  detail_id: "Detail Id",
  action_name: "Action Name",
  reports: "Report | Reports",
  report: "Report",
  sample_rpt: "Sample Report",
  security_tag: "Security Tag",
  security_code: "Security Code",
  submit: "Submit",
  disable: "Disable",
  operators: "Operator | Operators",
  members: "Member | Members",
  account_id: "Account ID",
  parent_id: "Parent ID",
  confirm_password: "Confirm Password",
  self_operate: "Self Operate",
  vip_mode: "VIP Mode",
  full_name: "Full Name",
  contact_phone: "Contact Phone",
  contact_email: "Contact Email",
  dashboard: "Dashboard",
  sub_account: "Sub Account",
  subaccount: "Sub Account",
  authority_option: "Authority Option",
  tickets: "Ticket | Tickets",
  banks: "Bank | Banks",
  vip_level: "Vip Level",
  login_ip : "Login Ip",
  block: "Block",
  profile_id: "Profile ID",
  suspend: "Suspend",
  dob: "DOB",
  mail_address: "Mail Address",
  deposit: "Deposit",
  withdrawal: "Withdrawal",
  rejected: "Rejected",
  processed: "Processed",
  pending: "Pending",
  member: "Member",
  amount: "Amount",
  bank_acc_no: "Bank Acc No.",
  deposit_date: "Deposit Date",
  deposit_method: "Deposit Method",
  approve: "Approve",
  reject: "Reject",
  remark: "Remark",
  ticket_detail: "Ticket Detail",
  promo: "Promo",
  package: "Package",
  created_date: "Created Date",
  currency: "Currency",
  bank_acc_holder: "Bank Acc Holder",
  ref_no: "Ref No.",
  vip: "VIP",
  vip_criteria: "VIP Criteria",
  requirement: "Requirement",
  level_1: "Level 1",
  level_1_name: "Level 1 Name",
  level_1_requirement: "Level 1 Requirement",
  level_1_multp: "Level 1 Multiplier",
  level_2: "Level 2",
  level_2_name: "Level 2 Name",
  level_2_requirement: "Level 2 Requirement",
  level_2_multp: "Level 2 Multiplier",
  level_3: "Level 3",
  level_3_name: "Level 3 Name",
  level_3_requirement: "Level 3 Requirement",
  level_3_multp: "Level 3 Multiplier",
  level_4: "Level 4",
  level_4_name: "Level 4 Name",
  level_4_requirement: "Level 4 Requirement",
  level_4_multp: "Level 4 Multiplier",
  level_5: "Level 5",
  level_5_name: "Level 5 Name",
  level_5_requirement: "Level 5 Requirement",
  level_5_multp: "Level 5 Multiplier",
  level_6: "Level 6",
  level_6_name: "Level 6 Name",
  level_6_requirement: "Level 6 Requirement",
  level_6_multp: "Level 6 Multiplier",
  level_7: "Level 7",
  level_7_name: "Level 7 Name",
  level_7_requirement: "Level 7 Requirement",
  level_7_multp: "Level 7 Multiplier",
  modified_date: "Modified Date",
  modified_by: "Modified By",
  bank_member: "Bank Member",
  bank_operator: "Bank Operator",
  bank_name: "Bank Name",
  bank_acc_type: "Bank Acc Type",
  login_user: "Login User",
  login_pwd: "Login Password",
  account_balance: "Account Balance",
  threshold: "Threshold",
  incoming: "Incoming",
  outgoing: "Outgoing",
  frequency: "Frequency",
  reset_threshold: "Reset Threshold",
  adjust_balance: "Adjust Balance",
  banking_mode: "Banking Mode",
  min_deposit: "Minimum Deposit",
  min_withdrawal: "Minimum Withdrawal",
  bank_from: "Bank From",
  bank_to: "Bank To",
  attachment: "Attachment",
  sender_bank: "Sender Bank",
  sender_bank_acc_no: "Sender Bank Acc No.",
  sender_bank_acc_holder: "Sender Bank Acc Holder",
  audit: "Audit",
  log_id: "Log ID",
  action_status: "Action Status",
  action_date: "Action Date",
  promotion: "Promotion",
  promotion_package: "Promotion Package",
  promotion_account: "Promotion Account",
  promo_id: "Promo ID",
  promo_name: "Promo Name",
  promo_desc: "Promo Description",
  packages: "Package | Packages",
  package_id: "Package ID",
  package_name: "Package Name",
  claim_type: "Claim Type",
  bonus_rate: "Bonus Rate",
  max_bonus: "Maximum Bonus",
  rollover: "Rollover",
  start_date: "Start Date",
  end_date: "End Date",
  provider_status: "Provider Status",
  own_status: "Own Status",
  package_own_status: "Package Own Status",
  ibank: "iBank",
  ibank_account: "iBank Account",
  ibank_acc_status: "iBank Account Status",
  download: "Download",
  min_balance: "Minimum Balance",
  parent: "Parent",
  adj_amount: "Adjust Amount",
  promotion_member: "Promotion Member",
  on_going: "On Going",
  knock_off: "Knock Off",
  deposit_amount: "Deposit Amount",
  base_amount: "Base Amount",
  bonus_amount: "Bonus Amount",
  bonus_id: "Bonus ID",
  target_amount: "Target Amount",
  claim_date: "Claim Date",
  accumulate_win: "Accumulate Win",
  accumulate_turnover: "Accumulate Turnover",
  knockoff_by: "Knock Off By",
  knockoff_date: "Knock Off Date",
  promo: "Promo",
  package: "Package",
  bonus: "Bonus",
  member_log: "Member Log",
  bonus_log: "Bonus Log",
  transfer_log: "Transfer Log",
  member_id: "Member ID",
  before_balance: "Before Balance",
  transfer_amount: "Transfer Amount",
  after_balance: "After Balance",
  created_by: "Created By",
  bonus_name: "Bonus Name",
  bonus_desc: "Bonus Description",
  bonus_type: "Bonus Type",
  add_promo: "Add Promotion",
  bonus_value: "Bonus Value",
  attach_promo: "Attach Promotion",
  issue_bonus: "Issue Bonus",
  daily_statement: "Daily Statement",
  working_date: "Working Date",
  opening_balance: "Opening Balance",
  turnover: "Turnover",
  valid_turnover: "Valid Turnover",
  winlose: "WinLose",
  withdrawal_amount: "Withdrawal Amount",
  closing_balance: "Closing Balance",
  sub_total: "Sub Total",
  grand_total: "Grand Total",
  daily_winlose: "Daily Winlose",
  game_result_slots: "Game Result Slots",
  game_result: "Game Result",
  bet_count: "Bet Count",
  result_id: "Result ID",
  bet_time: "Bet Time",
  payout: "Payout",
  game_type: "Game Type",
  game_name: "Game Name",
  game_provider: "Game Provider",
  loyalty_point_multp: "Loyalty Point Multiplier",
  vip_detail: "VIP Detail",
  reset: "Reset",
  mode: "Mode",
  balance: "Balance",
  min_bal_knock_off_promo: "Min Bal. (To auto knock off promotion)",
  social_account: "Social Account",
  wechat: "Wechat",
  skype: "Skype",
  line: "Line",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "Tiktok",
  qq: "QQ",
  twitter: "Twitter",
  viber: "Viber",
  future1: "Future1",
  future2: "Future2",
  future3: "Future3",
  login_log: "Login Log",
  failed: "Failed",
  web: "Web",
  mobile: "Mobile",
  platform: "Platform",
  bank_statement: "Bank Statement",
  transfer_date: "Transfer Date",
  detail: "Detail",
  date: "Date",
  transfer_list: "Transfer List",
  credit: "Credit",
  debit: "Debit",
  month: "Month",
  unblock: "Unblock",
  unblock_member: "Unblock Member",
  unblock_operator: "Unblock Operator",
  after_balance: "After Balance",
  referrer_id: "Referrer ID",
  referrer_code: "Referrer Code",
  referral_code: "Referral Code",
  bonus_and_adjustment: "Bonus & Adjustment",
  adjustment: "Adjustment",
  incoming_amount_threshold: "Incoming Amount Threshold",
  incoming_frequency_threshold: "Incoming Frequency Threshold",
  outgoing_amount_threshold: "Outgoing Amount Threshold",
  outgoing_frequency_threshold: "Outgoing Frequency Threshold",
  settle: "Settle",
  knock_off_by: "Knock Off By",
  knock_off_date: "Knock Off Date",
  accumulate_amount: "Accumulate Amount",
  deposit_amount: "Deposit Amount",
  total_turnover: "Total Turnover",
  total_winlose: "Total Winlose",
  total_deposit: "Total Deposit",
  total_withdrawal: "Total Withdrawal",
  total_member: "Total Member",
  active_player: "Active Player",
  top_winner: "Top Winner",
  top_loser: "Top Loser",
  winner: "Winner",
  loser: "Loser",
  deposit_count: "Deposit Count",
  withdrawal_count: "Withdrawal Count",
  bet_count: "Bet Count",
  summary: "Summary",
  alert: "Alert",
  incoming_threshold: "Incoming Threshold",
  incoming_frequency: "Incoming Frequency",
  outgoing_threshold: "Outgoing Threshold",
  outgoing_frequency: "Outgoing Frequency",
  reset_password: "Reset Password",
  authority_option: "Authority Option",
  transfer: "Transfer",
  company_bank: "Company Bank",
  company_bank_acc_no: "Company Bank Acc No.",
  company_bank_acc_holder: "Company Bank Acc Holder",
  registered_member: "Registered Member",
  promotion_report: "Promotion Report",
  deposited_member: "Deposited Member",
  referred_member: "Referred Member",
  validated_on: "Validated On",
  referrer: "Referrer",
  issue_livestream_bonus: "Issue Livestream Bonus",
  livestream_bonus: "Livestream Bonus",
  first_deposit: "First Deposit",
  first_deposit_at: "First Deposit At",
  nickname: "Nickname",
  member_nickname: "Member Nickname",
  free_spin: "Free Spin",
  reward: "Reward",
  in_game: "In Game",
  inbox: "Inbox",
  manual_bonus: "Manual Bonus",
  review: "Review | Reviews",
  review_list: "Review List",
  review_detail: "Review Detail",
  reply_review: "Reply Review",
  comment: "Comment",
  reply: "Reply",
  recipient_no: "Recipient No.",
  question : "Question",
  rating: "Rating",
  message: "Message",
  message_blast: "Message Blast",
  text: "Text",
  content: "Content",
  image: "Image",
  send: "Send",
  monthly_rating: "Monthly Rating",
  affiliate: "Affiliate",
  affiliate_list: "Affiliate List",
  approve_affiliate: "Approve Affiliate",
  affiliate_code: "Affiliate Code",
  approved_by: "Approved By",
  approved_date: "Approved Date",
  bank_affiliate: "Bank Affiliate",
  bank_id: "Bank ID",
  raise_ticket: "Raise Ticket",
  withdraw_amount: "Withdraw Amount",
  bank_add: "Bank Add",
  signup: "Signup",
  affiliate_signup: "Affiliate Signup",
  setup_bank: "Setup Bank",
  current_balance: "Current Balance",
  withdraw: "Withdraw",
  member_contribution: "Member Contribution",
  url: "Url",
  epicvip: "EPICVIP",
  epicwin8: "EPICWIN8",
  epicwin2: "EPICWIN2",
  copy: "Copy",
  settlement_list: "Settlement List",
  remaining: "Remaining",
  settled_amount: "Settled Amount",
  optional_fields: "Optional Fields",
  tac_code: "TAC Code",
  resend: "Resend",
  deal: "Deal",
  total_earning: "Total Earning",
  updated_on: "Updated On",
  total_player: "Total Player",
  tracking_link: "Tracking Link",
  brand: "Brand",
  link: "Link",
  player_id: "Player ID",
  total_revenue: "Total Revenue",
  earning_amount: "Earning Amount",
  players: "Player | Players",
  earning_breakdown: "Earning Breakdown",
  show_qr_code: "Show QR Code",
  year: "Year",
  promo_member: "Promotion Member",
  promo_player: "Promotion Player",
  qr: "QR",
  epicmas: "EPICMAS",
  share_whatsapp:"Share Whatsapp",
  share_facebook:"Share Facebook",
  share_telegram:"Share Telegram",
};


